import React, { useRef, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { useNotifications } from '../context/NotificationsContext';
import { useNavigate } from 'react-router-dom';
import './NotificationsBell.css';

import Loading from './Loading';
const NotificationsBell = () => {
  const {
    notifications,
    unreadCount,
    loading,
    isOpen,
    toggleDropdown,
    markAsRead,
    markAllAsRead,
  } = useNotifications();

  const navigate = useNavigate();
  const buttonRef = useRef(null);
  const dropdownRef = useRef(null);
  const [dropdownStyle, setDropdownStyle] = useState({});

  // Calcular posición del dropdown en base al botón (escapa overflow:hidden del sidebar)
  useEffect(() => {
    if (isOpen && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setDropdownStyle({
        top: rect.top - 8,   // justo sobre el botón
        left: rect.right + 8,
        transform: 'translateY(-100%)',
      });
    }
  }, [isOpen]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedButton = buttonRef.current && buttonRef.current.contains(event.target);
      const clickedDropdown = dropdownRef.current && dropdownRef.current.contains(event.target);
      if (!clickedButton && !clickedDropdown && isOpen) {
        toggleDropdown();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen, toggleDropdown]);

  const handleNotificationClick = async (notification) => {
    if (!notification.is_read) {
      await markAsRead(notification.id);
    }

    if (notification.target_url) {
      navigate(notification.target_url);
      toggleDropdown();
    }
  };

  const getNotificationIcon = (type) => {
    const icons = {
      'post_status_change': '📝',
      'post_approval': '✅',
      'post_rejection': '❌',
      'comment_mention': '💬',
      'task_assignment': '📋',
      'grilla_change': '📅',
    };
    return icons[type] || '🔔';
  };

  const dropdown = isOpen ? ReactDOM.createPortal(
    <div className="notifications-dropdown" ref={dropdownRef} style={dropdownStyle}>
      <div className="notifications-header">
        <h3>Notificaciones</h3>
        {unreadCount > 0 && (
          <button className="mark-all-read-btn" onClick={markAllAsRead}>
            Marcar todas como leídas
          </button>
        )}
      </div>

      <div className="notifications-list">
        {loading && <Loading fullScreen={false} size="sm" />}

        {!loading && notifications.length === 0 && (
          <div className="notifications-empty">No tienes notificaciones</div>
        )}

        {!loading && notifications.map((notification) => (
          <div
            key={notification.id}
            className={`notification-item ${notification.is_read ? 'read' : 'unread'}`}
            onClick={() => handleNotificationClick(notification)}
          >
            <div className="notification-icon">
              {getNotificationIcon(notification.notification_type)}
            </div>
            <div className="notification-content">
              <div className="notification-message" dangerouslySetInnerHTML={{ __html: notification.verb }}></div>
              <div className="notification-time">Hace {notification.time_ago}</div>
            </div>
            {!notification.is_read && (
              <div className="notification-unread-dot"></div>
            )}
          </div>
        ))}
      </div>
    </div>,
    document.body
  ) : null;

  return (
    <div className="notifications-bell-container">
      <button
        ref={buttonRef}
        className="notifications-bell-button"
        onClick={toggleDropdown}
        aria-label="Notificaciones"
      >
        <span className="bell-icon"><i className="bi bi-bell-fill" /></span>
        {unreadCount > 0 && (
          <span className="notifications-badge">
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
        )}
      </button>
      {dropdown}
    </div>
  );
};

export default NotificationsBell;
